/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { ID } from '@gh/common-shared-data';
import { AbstractRestService, arrayOf, RestSettings, SlicedDataSource } from '@gh/core-data';

import { Observable } from 'rxjs';

import { JobFinancialsDto } from './job-financials.dto';
import { JobFinancialsMapper } from './job-financials.mapper';
import { JobListFilterDto, JobListItemDto } from '../job.dto';
import { JobListFilterMapper, JobListItemMapper } from '../job.mapper';

@Injectable()
export class JobFinancialsRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  get(jobId: ID): Observable<JobFinancialsDto> {
    return this.httpGet(`${this.accounting}/jobs/${jobId}/financials`, JobFinancialsMapper);
  }

  findAllAsDataSource(filter: JobListFilterDto): SlicedDataSource<JobListItemDto> {
    return this.createSlicedDataSourceGet(`${this.jad}/job-financials`,
                                          filter, JobListFilterMapper, arrayOf(JobListItemMapper));
  }
}
